import _ from 'lodash'

/**
 * 营销系统活动工具库
 * * taskResolver: 判断用户在此方案下的任务下是否能进行参与，详见下面说明
 */
export default {
  /**
   * 方案任务处理代码表
   */
  taskResolverCodes: {
    noWhite: 'noWhite',

    hadJoin: 'hadJoin',
    hadJoinMonth: 'hadJoinMonth',
    hasJoinWeek: 'hasJoinWeek',
    hadJoinDay: 'hadJoinDay',

    grabOver: 'grabOver',
    grabOverMonth: 'grabOverMonth',
    grabOverWeek: 'grabOverWeek',
    grabOverDay: 'grabOverDay',

    noInfo: 'noInfo',
    over: 'over',
    noBegin: 'noBegin',
  },

  /**
   * 处理方案任务并返回结果
   * * 这个函数当前只支持判断一个 taskObj 是否有库存、是否能参与，是否白名单，等等
   * * 失败情况下：success: false, msg: 'string', code: noWhite非白名单/hadJoin已参与/grabOver已抢完/noInfo没有有效信息/over已结束/noBegin还没开始
   * * 成功情况下：success: true,
   * @param taskInfo {Object} 任务，一般由 taskList[i] 这种组成
   * @returns {object} {success:true/false, msg, code}
   */
  taskResolver (taskInfo) {
    const codes = this.taskResolverCodes
    this.taskResolver.codes = codes

    const { rewardConfigList = [] } = taskInfo || {}
    const action = _.get((taskInfo || {}), ['actionList', 0], {})

    // 0, 判断有无信息
    if (!taskInfo || !action) {
      return ({
        success: false,
        msg: '方案或模板配置错误',
        code: codes.noInfo
      })
    }

    // 0.1 判断方案状态
    if (taskInfo) {
      const { state } = taskInfo
      let msg = ''
      let code = ''
      if (state === '6') {
        msg = '活动暂未开始哦！'
        code = codes.noBegin
      } else if (state === '7' || state === '9') {
        msg = '活动已结束啦！请期待下期活动哦~'
        code = codes.over
      }
      if (msg) {
        return ({
          success: false,
          msg,
          code
        })
      }
    }

    // 1, 判断白名，非白名，只有 === '0' 这种为黑，其他都是白
    // 无门槛的情况下会返回 null
    // 白名单查库行为查询是没有返回的，只能调用收集行为判断，故有时，一个方案的任务的行为是：白名单查库行为
    // 这种情况只能用“收集行为”来判断白名（from suHengCong）
    if (('' + action.isWhite) === '0') {
      return ({
        success: false,
        msg: '您不是本次活动的目标用户，请期待我行其他活动',
        code: codes.noWhite
      })
    }


    // 2, 判断是否已经参加过了 已参与过(更准确的描述是暂时不能再参与)
    if (taskInfo.taskResult === '1') {
      // 下面这一段，根据不同的业务可以放出来使用
      let {
        canJoinTimes,
        canJoinTimesDay,
        canJoinTimesWeek,
        canJoinTimesMonth
      } = taskInfo
      let msg = ''
      let code = ''
      if (parseInt(canJoinTimes) > 0) {
        if (canJoinTimesMonth === '0') {
          msg = '您本月已经参与过活动了，请下月再来参与吧。'
          code = codes.hadJoinMonth
        } else if (canJoinTimesWeek === '0') {
          msg = '您本周已经参与过活动了，请下周再来参与吧。'
          code = codes.hasJoinWeek
        } else if (canJoinTimesDay === '0') {
          msg = '您今天已经参与过活动了，请明天再来参与吧。'
          code = codes.hadJoinDay
        } else {
          msg = '您今天已经参与过活动了，请明天再来参与吧。'
          code = codes.hadJoin
        }
      } else {
        msg = '您已经参与过活动。'
        code = codes.hadJoin
      }
      return ({
        success: false,
        msg,
        code,
      })
    }


    // 3, 判断业务量 其它业务量限制（单日，单周，单月限制）
    if (taskInfo) {
      const {
        dayBalance,
        monthBalance,
        totalBalance,
        weekBalance
      } = taskInfo

      let msgBalance = ''
      let code = codes.grabOver
      if (totalBalance === '0') {
        msgBalance = '您来迟啦~奖品已被抢光啦！'
      } else if (monthBalance === '0') {
        msgBalance = '本月奖品已被抢光，下月再来吧~'
        code = codes.grabOverMonth
      } else if (weekBalance === '0') {
        msgBalance = '本周奖品已被抢光，下周再来吧~'
        code = codes.grabOverWeek
      } else if (dayBalance === '0') {
        msgBalance = '今日奖品已被抢光，明日再来吧~'
        code = codes.grabOverDay
      }
      if (msgBalance) {
        return ({
          success: false,
          msg: msgBalance,
          code,
        })
      }
    }


    // 4, 判断库存量
    if (taskInfo) {
      let totalLimited = 0 // 总库存已限制
      let dayLimited = 0 // 日库存已限制
      let itemCount = 0 // 总奖品类目数

      for (let i = 0; i < rewardConfigList.length; i++) {
        const rewardConfig = rewardConfigList[i]
        for (let j = 0; j < rewardConfig.combiList.length; j++) {
          itemCount++
          const combi = rewardConfig.combiList[j]
          const {
            combiName,
            rewardNum, // 总库存
            edayNum, // 每日库存
            useEdayNum, // 单日已领
            useRewardNum, // 总已领
          } = combi

          if (edayNum) {
            if (edayNum - (useEdayNum || 0) < 1) {
              dayLimited++
              // 当日库存没了
              console.log(combiName, '当日库存没了')
            }
          }
          if (rewardNum) {
            if (rewardNum - (useRewardNum || 0) < 1) {
              totalLimited++
              // 总库存没了
              console.log(combiName, '总库存没了')
            }
          }
        }
      }

      if (itemCount) {
        let msg = ''
        if (totalLimited === itemCount) {
          msg = '您来迟啦~奖品已被抢光啦！'
        } else if (dayLimited === itemCount) {
          msg = '今日名额已抢完~请明天再来哦！'
        }
        if (msg) {
          return ({
            success: false,
            msg,
            code: codes.grabOver
          })
        }
      }
    }

    // 5. 如果所有过滤条件都校验通过，那就是allSuccess了
    return ({
      success: true,
      code: '',
      msg: '',
    })
  },

  /**
   * 根据 code 返回不同的提示，一般用于收集行为失败后的code映射
   * @param code
   */
  collectActionErrMsg (code) {
    const obj = {
      '400038': '活动已结束，敬请期待下次活动哦~',
      '400032': '您本月已参与该活动~',             // 超月参与次数
      '410015': '登录失败，请重新登录',
      '410035': '活动已结束，敬请期待下次活动哦~',
      '437002': '您已经参与此活动，敬请关注其他活动~',
      '437004': '您已经参与此活动，敬请关注其他活动~',
      '450001': '您非本次活动目标用户，敬请关注其他活动~'
    }
    return obj[code] || ''
  },

  /**
   * 根据 code 返回不同提示，用于查询方案时使用
   * @param code
   */
  querySchemeErrorMsg (code) {
    const obj = {
      '435007': '今天的奖品被领完了~',
      '400037': '活动未开始，敬请期待其他活动~',
      '400038': '活动已过期，敬请期待我行其他活动~',
      '410015': '登录过期，请重新登录~',
    }
    return obj[code] || ''
  },

  /**
   * 奖品的列表的 state 匹配
   */
  awardStates: {
    '0': '待派发',
    '1': '已派发',
    '2': '派发中',
    '-1': '派发失败',
    '-2': '已过期'
    // <!--0 k 1 发货成功 2 发货中，4待选择，发货申请后，变更为发货中；发货接口返回信息后再变更；以防重复发货；
    //  -1 发货失败，发货失败后，由操作界面申请发货 -2 作废，当前时间超过截止日期时，返回这个状态给前端-->
  },
}
